/**
 * Auto-generated by tools/content-pipeline.
 * Pack: wordsearch-themedshape-v1
 * Item: wordsearch-garden
 * Generated: 2026-06-06T02:43:04.417Z
 * Generator: google/gemini-2.5-flash  |  Judge: anthropic/claude-sonnet-4.5
 * Accepted: 57 items (judge threshold 0.70)
 * Edit this file by re-running the pipeline; do not hand-edit unless you know what you are doing.
 */
export const gardenWords = [
    {
        "word": "DAISY"
    },
    {
        "word": "TULIP"
    },
    {
        "word": "ROSE"
    },
    {
        "word": "PEONY"
    },
    {
        "word": "LILAC"
    },
    {
        "word": "VIOLET"
    },
    {
        "word": "IRIS"
    },
    {
        "word": "PLANT"
    },
    {
        "word": "BLOOM"
    },
    {
        "word": "SPROUT"
    },
    {
        "word": "EGGPLANT"
    },
    {
        "word": "CARROT"
    },
    {
        "word": "TOMATO"
    },
    {
        "word": "RADISH"
    },
    {
        "word": "ONION"
    },
    {
        "word": "PEAPOD"
    },
    {
        "word": "BEET"
    },
    {
        "word": "CABBAGE"
    },
    {
        "word": "CELERY"
    },
    {
        "word": "BEAN"
    },
    {
        "word": "WEED"
    },
    {
        "word": "WATER"
    },
    {
        "word": "TROWEL"
    },
    {
        "word": "SHOVEL"
    },
    {
        "word": "RAKE"
    },
    {
        "word": "GLOVES"
    },
    {
        "word": "DIBBER"
    },
    {
        "word": "SPRINKLE"
    },
    {
        "word": "SHEARS"
    },
    {
        "word": "TRELLIS"
    },
    {
        "word": "ARBOR"
    },
    {
        "word": "FENCE"
    },
    {
        "word": "BENCH"
    },
    {
        "word": "PATH"
    },
    {
        "word": "FOUNTAIN"
    },
    {
        "word": "MOSS"
    },
    {
        "word": "SOIL"
    },
    {
        "word": "DIRT"
    },
    {
        "word": "MULCH"
    },
    {
        "word": "COMPOST"
    },
    {
        "word": "FERTILIZE"
    },
    {
        "word": "GROW"
    },
    {
        "word": "PRUNE"
    },
    {
        "word": "HARVEST"
    },
    {
        "word": "GARDEN"
    },
    {
        "word": "PETAL"
    },
    {
        "word": "LEAF"
    },
    {
        "word": "STEM"
    },
    {
        "word": "ROOT"
    },
    {
        "word": "SEED"
    },
    {
        "word": "EARTH"
    },
    {
        "word": "WORM"
    },
    {
        "word": "PLOT"
    },
    {
        "word": "GRASS"
    },
    {
        "word": "MINT"
    },
    {
        "word": "HERB"
    },
    {
        "word": "LILY"
    }
];
//# sourceMappingURL=garden.js.map